import { render, staticRenderFns } from "./CarShowButton.vue?vue&type=template&id=2b460f29&scoped=true&"
import script from "./CarShowButton.vue?vue&type=script&lang=ts&"
export * from "./CarShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./CarShowButton.vue?vue&type=style&index=0&id=2b460f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b460f29",
  null
  
)

export default component.exports